import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { RestService } from '../rest.service';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ExcelexportService } from '../excelexport.service';

@Component({
  selector: 'app-factplaza',
  templateUrl: './factplaza.component.html',
  styleUrls: ['./factplaza.component.scss']
})
export class FactplazaComponent implements OnInit {

  rangos: any[] = [];
  data: any[] = [];

  dateSimple;
  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.dateSimple = dateStr;
      this.ObtenerFechaComparacion();
    }
  };

  dateComparativa;
  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.dateComparativa = dateStr;
    }
  };

  rango_selected;

  constructor(
    private rest: RestService,
    private excel: ExcelexportService,
    public user: UserService ) {
      this.GetRangos();
      this.GetDefault();
    }

  ngOnInit() {}

  GetRangos() {
    this.rest.GetRangos().subscribe((data) => {
      this.rangos = data['data'];
    });
  }

  exportXlsx() {


    const promise = new Promise( (resolve) => {
      let general = [];
      let comparativa = [];
      let diferencia = [];

      for (let index = 0; index < this.data.length; index++) {
        general[index] = {
          'concepto' : this.data[index]['concepto'],
          'gandia' : this.data[index]['gandia']['general'],
          'ontinyent' : this.data[index]['ontinyent']['general'],
          'torrent' : this.data[index]['torrent']['general'],
          'villena' : this.data[index]['villena']['general'],
        };

        comparativa[index] = {
          'concepto' : this.data[index]['concepto'],
          'gandia' : this.data[index]['gandia']['comparativa'],
          'ontinyent' : this.data[index]['ontinyent']['comparativa'],
          'torrent' : this.data[index]['torrent']['comparativa'],
          'villena' : this.data[index]['villena']['comparativa'],
        };

        diferencia[index] = {
          'concepto' : this.data[index]['concepto'],
          'gandia' : this.data[index]['gandia']['diferencia'],
          'ontinyent' : this.data[index]['ontinyent']['diferencia'],
          'torrent' : this.data[index]['torrent']['diferencia'],
          'villena' : this.data[index]['villena']['diferencia'],
        };
      }

      resolve([general, comparativa, diferencia]);
    });

    promise.then( (arrayResult: any[]) => {
      this.excel.fact2Export(
        arrayResult[0], arrayResult[1], arrayResult[2],'PLAZA_' + this.dateSimple + 'VS' + this.dateComparativa);
    });

  }

  ObtenerFechaComparacion() {
    this.rest.Getfecha_comparacion(this.user.formatDate(this.dateSimple))
    .subscribe(
      (data) => this.dateComparativa = data['data'][0]['fecha'] );
  }

  parseInt(myAcc) {
    let intValue = parseInt(myAcc);

    if (intValue >= 0) {
        return true;
    } else {
        return false;
    }
  }

  GetDefault() {
    this.rest.GetDefault().subscribe( (data) => {
      this.rango_selected = data['data'].rango;

      this.dateSimple = {
        year: new Date(data['data'].general).getFullYear(),
        month: new Date(data['data'].general).getMonth() + 1 ,
        day: new Date(data['data'].general).getDate()
      };

      this.dateComparativa = {
        year: new Date(data['data'].comparacion).getFullYear(),
        month: new Date(data['data'].comparacion).getMonth() + 1 ,
        day: new Date(data['data'].comparacion).getDate()
      };

    });
  }

  GetData() {
    this.rest.GetDataPlaza(this.rango_selected.id, this.user.formatDate(this.dateSimple), this.user.formatDate(this.dateComparativa) )
    .subscribe( (data) => this.data = data['data'] );
  }



}
